import { render, staticRenderFns } from "./addTemplate.vue?vue&type=template&id=1b863182&scoped=true&"
import script from "./addTemplate.vue?vue&type=script&lang=js&"
export * from "./addTemplate.vue?vue&type=script&lang=js&"
import style0 from "./addTemplate.vue?vue&type=style&index=0&id=1b863182&prod&scoped=true&lang=css&"
import style1 from "./addTemplate.vue?vue&type=style&index=1&id=1b863182&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b863182",
  null
  
)

export default component.exports